import { getRequestAdType, removeUndefined } from '../helpers'

/**
 * DTO: Transform FormDataRequestAds (form data) to PayloadRequestAds (API payload)
 */
export const bodyRequestAdsDTO = (
  formData: FormDataRequestAds
): PayloadRequestAds => {
  const shouldIncludeSize = [
    'banner',
    'banner_video',
    'banner_off_site'
  ].includes(formData.type)

  const payload = {
    context: formData.context,
    device: 'desktop',
    term: formData.term,
    category_name: formData?.targeting?.categories,
    product_sku: formData.product_sku,
    brand_name: formData.brand_name,
    session_id: formData.session_id || `request-tester-${formData.context}`,
    user_id: formData.user_id || null,
    brand: formData.brand,
    store_id: formData?.store_id,
    channel: formData.channel || 'site',
    dedup_campaign_ads: formData.dedup_campaign_ads || false,
    dedup_ads: formData.dedup_ads || false,
    placements: {
      placementRequestTester: removeUndefined({
        types: [getRequestAdType(formData.type)],
        quantity: Number(formData.quantity),
        size: shouldIncludeSize ? formData.size || undefined : undefined,
        assets_type: ['banner_video', 'sponsored_brand_video'].includes(
          formData.type
        )
          ? ['video']
          : ['image']
      }) as PlacementRequest
    }
  }

  if (!formData?.store_id) {
    delete payload.store_id
  }

  return payload as PayloadRequestAds
}
